import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'questionType'
})
export class QuestionTypePipe implements PipeTransform {

  transform(value: string): string {
    let response = ''
    switch (value) {
      case 'text':
        response = 'Texto';
        break;
      case 'number':
        response = 'Número';
        break;
      case 'multiple':
        response = 'Selección múltiple';
        break;
      case 'checkbox':
        response = 'Selección única';
        break;
      case 'conditional':
        response = 'Condicional';
      break;
    }

    return response;
  }

}
